export default {
    groupName: 'hyundai',
    appName: 'Hyundai',
    baseRoute: '/dashboard/hyundai',
    label: 'Hyundai Ad Effect Tracker',
    home: '/slicer',
    image: 'hyundai.png',
    description: 'Hyundai Ad Effect Tracker'
}


// WEBPACK FOOTER //
// ./src/app/configuration/Hyundai/config/main.js